import * as Types from '../types-api.generated';

import { useQuery, useInfiniteQuery, UseQueryOptions, UseInfiniteQueryOptions, InfiniteData } from '@tanstack/react-query';
import { apiFetcher } from 'lib/clients/graphql';

import { ClientError } from "graphql-request";
import { Address } from "viem";
import { ChainId } from "lib/chains";

export type ApiDropAllowlistVariables = Types.Exact<{
  drop: Types.ApiCollectionInput;
}>;


export type ApiDropAllowlist = { dropAllowlist: { isAllowListed: boolean, merkleProof: Array<string> | null } };



export const ApiDropAllowlistDocument = /*#__PURE__*/ `
    query DropAllowlist($drop: CollectionInput!) {
  dropAllowlist(collection: $drop) {
    isAllowListed
    merkleProof
  }
}
    `;

export const useDropAllowlist = <
      TData = ApiDropAllowlist,
      TError = ClientError
    >(
      variables: ApiDropAllowlistVariables,
      options?: Omit<UseQueryOptions<ApiDropAllowlist, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ApiDropAllowlist, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ApiDropAllowlist, TError, TData>(
      {
    queryKey: ['DropAllowlist', variables],
    queryFn: apiFetcher<ApiDropAllowlist, ApiDropAllowlistVariables>(ApiDropAllowlistDocument, variables),
    ...options
  }
    )};

useDropAllowlist.getKey = (variables: ApiDropAllowlistVariables) => ['DropAllowlist', variables];

export const useInfiniteDropAllowlist = <
      TData = InfiniteData<ApiDropAllowlist>,
      TError = ClientError
    >(
      variables: ApiDropAllowlistVariables,
      options: Omit<UseInfiniteQueryOptions<ApiDropAllowlist, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<ApiDropAllowlist, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<ApiDropAllowlist, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['DropAllowlist.infinite', variables],
      queryFn: (metaData) => apiFetcher<ApiDropAllowlist, ApiDropAllowlistVariables>(ApiDropAllowlistDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteDropAllowlist.getKey = (variables: ApiDropAllowlistVariables) => ['DropAllowlist.infinite', variables];


useDropAllowlist.fetcher = (variables: ApiDropAllowlistVariables, options?: RequestInit['headers']) => apiFetcher<ApiDropAllowlist, ApiDropAllowlistVariables>(ApiDropAllowlistDocument, variables, options);
